export default {
  SET_USERS(state, users) {
    state.users = users;
    for(var i = 0; i<state.users.length; i++){
      state.users[i].fullname = state.users[i].firstname + ' ' + state.users[i].lastname;
    }
  }
};